const language = localStorage.getItem("language");
export const langDir = "ltr";

export default language;
